
import React, { useState, useEffect } from 'react';
import { Pie, Bar } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement } from 'chart.js';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import api from '../mainApi';

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement);
const localizer = momentLocalizer(moment);

const Dashboard = () => {
  const [stats, setStats] = useState({
    totalMembers: 0,
    membersByPlan: {},
    totalClasses: 0,
    classesToday: 0,
    totalRevenue: 0,
    monthlyRevenue: {}
  });
  const [events, setEvents] = useState([]);

  useEffect(() => {
    api.get('dashboard/stats')
      .then(res => setStats(res.data))
      .catch(error => console.error('Error fetching dashboard stats:', error));

    api.get('events')
      .then(res => setEvents(res.data))
      .catch(error => console.error('Error fetching events:', error));
  }, []);

  const memberDistData = {
    labels: Object.keys(stats.membersByPlan),
    datasets: [
      {
        label: '# of Members',
        data: Object.values(stats.membersByPlan),
        backgroundColor: [
          'rgba(255, 99, 132, 0.2)',
          'rgba(54, 162, 235, 0.2)',
          'rgba(255, 206, 86, 0.2)',
        ],
        borderColor: [
          'rgba(255, 99, 132, 1)',
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };

  const monthlyRevenueData = {
    labels: Object.keys(stats.monthlyRevenue),
    datasets: [
      {
        label: 'Monthly Revenue',
        data: Object.values(stats.monthlyRevenue),
        backgroundColor: 'rgba(75, 192, 192, 0.2)',
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1,
      },
    ],
  };

  const calendarEvents = events.map(event => ({
    id: event.id,
    title: event.title,
    start: new Date(event.event_date),
    end: new Date(event.event_date),
    allDay: true,
  }));

  return (
    <div>
      <h2>Dashboard</h2>
      <div className="row">
        <div className="col-md-3">
          <div className="card text-white bg-primary mb-3">
            <div className="card-header">Total Members</div>
            <div className="card-body">
              <h5 className="card-title">{stats.totalMembers}</h5>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card text-white bg-success mb-3">
            <div className="card-header">Total Classes</div>
            <div className="card-body">
              <h5 className="card-title">{stats.totalClasses}</h5>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card text-white bg-warning mb-3">
            <div className="card-header">Classes Today</div>
            <div className="card-body">
              <h5 className="card-title">{stats.classesToday}</h5>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card text-white bg-danger mb-3">
            <div className="card-header">Total Revenue</div>
            <div className="card-body">
              <h5 className="card-title">${stats.totalRevenue}</h5>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <div className="card">
            <div className="card-header">Member Distribution by Plan</div>
            <div className="card-body">
              <Pie data={memberDistData} />
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="card">
            <div className="card-header">Monthly Revenue</div>
            <div className="card-body">
              <Bar data={monthlyRevenueData} />
            </div>
          </div>
        </div>
      </div>

      <div className="row mt-4">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header">Upcoming Events</div>
            <div className="card-body">
              <div style={{ height: '400px' }}>
                <Calendar
                  localizer={localizer}
                  events={calendarEvents}
                  startAccessor="start"
                  endAccessor="end"
                  views={['month']}
                  defaultView="month"
                  toolbar={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;